module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.2d0a0d8f.eot";